module.exports = __webpack_public_path__ + "static/img/game1.9207f46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/game1.png
// module id = D18j
// module chunks = 1